/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Group, ThemeIcon, ThemeIconProps } from '@mantine/core'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'

export type CheckboxIconProps = ThemeIconProps & {
  checked: boolean,
  label?: ReactNode,
}

function CheckboxIcon (props: CheckboxIconProps) {
  const { checked, label, ...others } = props
  return (
    <Group gap="xs" wrap="nowrap">
      <ThemeIcon
        size="xs"
        color={checked ? 'green' : 'red'}
        {...others}
      >
        <FontAwesomeIcon
          fixedWidth
          icon={checked ? faCheck : faTimes}
        />
      </ThemeIcon>
      {label}
    </Group>
  )
}

export default CheckboxIcon
